export default __webpack_public_path__ + "static/phone-with-IMI-v2-09a98914f3e8c654a44eae5e09e893c7.png";